//#region Styles
import { ContainerParts } from "components/styles";
//#endregion
//#region Components
import Part1 from "./components/Part1/Part1";
import Part2 from "./components/Part2/Part2";
import Part3 from "./components/Part3/Part3";
//#endregion

const Step2 = ({
    dataRelatedToForm, 
    form, changeForm, errors, 
    changeErrorText, errorTexts
}) => {
    const changeFieldPart1 = (field, value, errorValue) => {
        changeForm("part1", field, value, errorValue);
    }
    const changeFieldPart2 = (field, value, errorValue) => {
        changeForm("part2", field, value, errorValue);
    }
    const changeFieldPart3 = (field, value, errorValue) => {
        changeForm("part3", field, value, errorValue);
    }
    return (
        <ContainerParts>
            <Part1 
                form={form.part1}
                changeField={changeFieldPart1}
                errors={errors.part1}/>
            <Part2
                form={form.part2}
                changeField={changeFieldPart2}
                changeErrorText={changeErrorText}
                errors={errors.part2}
                errorTexts={errorTexts}/>
            <Part3
                dataRelatedToForm={dataRelatedToForm}
                form={form.part3}
                changeField={changeFieldPart3}
                errors={errors.part3}
                errorTexts={errorTexts}/>
        </ContainerParts>
    );
}

export default Step2;